import React, { useState, useEffect, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const GuestsCalendar = ({ apartmentId, onClose }) => {
  const [dailyPrices, setDailyPrices] = useState({});
  const [dateRange, setDateRange] = useState([null, null]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const modalRef = useRef(null);

  const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_URL || "http://localhost:8000";
  };

  useEffect(() => {
    const fetchDailyPrices = async () => {
      if (!apartmentId) {
        console.warn("No apartmentId provided, skipping fetch.");
        return;
      }

      setIsLoading(true);
      setError("");

      try {
        const token = localStorage.getItem("token");
        const headers = {
          "Content-Type": "application/json",
        };

        if (token) {
          headers["Authorization"] = `Token ${token}`;
        }

        const fullUrl = `${getApiBaseUrl()}/api/properties/apartments/${apartmentId}/daily-prices/`;
        console.log("Fetching daily prices from:", fullUrl);

        const response = await fetch(fullUrl, {
          method: "GET",
          headers,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch daily prices: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Daily prices data:", data);

        const prices = data.reduce((acc, item) => {
          acc[item.date] = parseFloat(item.price);
          return acc;
        }, {});

        setDailyPrices(prices);
      } catch (error) {
        console.error("Error fetching daily prices:", error);
        setError("Failed to fetch daily prices. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDailyPrices();
  }, [apartmentId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const formattedDate = formatDate(date);
      const price = dailyPrices[formattedDate];
      return price ? <p className="text-green-500">${price.toFixed(2)}</p> : null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div
        ref={modalRef}
        className="bg-white p-6 rounded-lg shadow-lg w-96 relative"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✖
        </button>

        <h2 className="text-xl font-bold mb-4">Select Date Range</h2>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <p>Loading prices...</p>
          </div>
        ) : (
          <>
            <Calendar
              onChange={setDateRange}
              selectRange={true}
              tileContent={tileContent}
            />

            {dateRange[0] && dateRange[1] && (
              <div className="mt-4">
                <h3 className="text-lg font-semibold">
                  Selected Range: {formatDate(dateRange[0])} to {formatDate(dateRange[1])}
                </h3>
              </div>
            )}
          </>
        )}

        {error && <p className="text-red-500 mt-2">{error}</p>}
      </div>
    </div>
  );
};

export default GuestsCalendar;
